(function ($, SCS, debug) {
	'use strict';

	/**
	 * Create namespaces
	 */
	SCS.TV = SCS.TV || {};

	

	/**
	 * SportEvent Class
	 * Represents a Sport-Event (which contains multiple broadcasts)
	 */
	function SportEvent(sportEventId, callback) {
		debug.log('SCS.TV > SportEvent > new', sportEventId, callback);
		this._init(sportEventId, callback);
	}

	SportEvent.getDetailsUrl = function(sportEventId) {
		return SCS.Const.SNOOPY_SHARING_URL + 'L=' + SCS.Const.SNOOPY_LANGUAGE + '&T=Sport&I=' + sportEventId;
	};

	// class functions
	SportEvent.prototype = {
		constructor: SportEvent,
		
		_init: function(sportEventId, callback) {
			this.sportEventId = sportEventId;
			this.title = '';
			this.broadcasts = [];
			this.firstParticipant = null; // {'name':'', 'logo': ''}
			this.secondParticipant = null;

			if (sportEventId) {
				this._loadData(callback);
			}
		},

		_loadData: function(callback) {
			var sportEvent = this;
			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/sport/' + SCS.Const.SNOOPY_LANGUAGE + '/events/list/(ids=' + this.sportEventId + ');', function (data) {
				debug.log('SCS.TV > sportEventId > loadData', data);
				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					var eventInfo = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(data.Nodes.Items, 'Container', 'EventGroup');
					if (eventInfo) {
						sportEvent._readData(eventInfo);
					}
				}
				if (typeof callback === 'function') {
					callback(sportEvent);
				}
			});
		},

		_readData: function(eventInfo) {
			var tempBroadcasts,
				tempBroadcast,
				tempChannel;

			this.sportEventId = eventInfo.Identifier;

			// important: title language is dependant on event-id specified (there's a event-id for each language)
			// as sportal delivers only one language - always use their title or the broadcast-title of the automatically-selected broadcast
			if (eventInfo && eventInfo.Content && eventInfo.Content.Description) {
				this.title = eventInfo.Content.Description.Title;
			}

			// find participants (1 or 2 depending on the type of sport)
			if (eventInfo.Relations) {
				var partitipants = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(eventInfo.Relations, 'Participant', null, null, 2);
				if (partitipants && partitipants.length > 0) {
					this.firstParticipant = this._readParticipantData(partitipants[0]);
					if (partitipants.length > 1) {
						this.secondParticipant = this._readParticipantData(partitipants[1]);
					}
				}
			}

			// read all broadcasts of this sportevent
			if (eventInfo && eventInfo.Content && eventInfo.Content.Nodes && eventInfo.Content.Nodes.Items) {
				tempBroadcasts = eventInfo.Content.Nodes.Items;
				for (var i = 0; i < tempBroadcasts.length; i++) {
					if (tempBroadcasts[i].Kind === 'Broadcast' && tempBroadcasts[i].Content && tempBroadcasts[i].Content.Description && tempBroadcasts[i].Availabilities && tempBroadcasts[i].Availabilities.length > 0) {
						
						if (tempBroadcasts[i].Relations) {
							tempChannel = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(tempBroadcasts[i].Relations, 'Reference', 'ChannelIdentifier');
						}
						
						tempBroadcast = new SCS.TV.Broadcast();
						tempBroadcast.broadcastId = tempBroadcasts[i].Identifier;
						tempBroadcast.title = this.title;
						tempBroadcast.summary = '';
						tempBroadcast.language = tempBroadcasts[i].Content.Description.Language;
						tempBroadcast.start = SCS.Const.SNOOPY_IS_OLD_IE ? SCS.TV.Helper.readDateIE8(tempBroadcasts[i].Availabilities[0].AvailabilityStart) : new Date(tempBroadcasts[i].Availabilities[0].AvailabilityStart);
						tempBroadcast.end = SCS.Const.SNOOPY_IS_OLD_IE ? SCS.TV.Helper.readDateIE8(tempBroadcasts[i].Availabilities[0].AvailabilityEnd) : new Date(tempBroadcasts[i].Availabilities[0].AvailabilityEnd);
						tempBroadcast.duration = Math.round((tempBroadcast.end - tempBroadcast.start) / 60000);
						tempBroadcast.price = tempBroadcasts[i].Availabilities[0].Price;
						if (tempBroadcast.price > 0) { // web users pay 2.- more to rent the stream
							tempBroadcast.price += SCS.Const.SNOOPY_WEB_RENT_SURCHARGE;
						}
						tempBroadcast.currency = tempBroadcasts[i].Availabilities[0].Currency;
						tempBroadcast.channelId = tempChannel ? tempChannel.TargetIdentifier : '';
						tempBroadcast.posterUrl = SCS.TV.Broadcast.posterUrl.replace('{broadcastid}', tempBroadcast.broadcastId);

						this.broadcasts.push(tempBroadcast);
					}
				}

			}

		},

		/**
		 * reads paritipant node and returns object with name and logo-url
		 */
		_readParticipantData: function(participantNode) {
			var participant = {},
				logoNode;
			if (participantNode.TargetNode.Content && participantNode.TargetNode.Content.Description) {
				participant.name = participantNode.TargetNode.Content.Description.Title;
			}
			if (participantNode.TargetNode.Content && participantNode.TargetNode.Content.Nodes && participantNode.TargetNode.Content.Nodes) {
				logoNode = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(participantNode.TargetNode.Content.Nodes.Items, 'Image', 'Logo');
				if (logoNode) {
					participant.logo = SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'content/images/sport/participant/' + logoNode.Identifier + '_W90.png';
				}
			}
			return participant;

		},

		/**
		 * Tries to automatically select the correct broadcast for a sportevent
		 * Strangely - there are TV channels with no price - but these cannot be used here, as they are the channels
		 * that are integrated into a subscription. Therefore all broadcasts that have no price, are excluded
		 * @lang can be used to override default language
		 */
		getAutomaticSelectedBroadcast: function(lang) {
			var broadcastsWithBestLanguage = [],
				broadcastsWithPrice = [],
				cheapest = null;

			if (!lang) {
				lang = SCS.Const.SNOOPY_LANGUAGE;
			}

			for (var i = 0; i < this.broadcasts.length; i++) {
				if (this.broadcasts[i].language && this.broadcasts[i].language.indexOf(lang) === 0) {
					broadcastsWithBestLanguage.push(this.broadcasts[i]);
				}
			}
			if (broadcastsWithBestLanguage.length === 0) {
				broadcastsWithBestLanguage = this.broadcasts;
			}

			if (broadcastsWithBestLanguage.length === 0) {
				return null;
			}

			for (i = 0; i < broadcastsWithBestLanguage.length; i++) {
				if (broadcastsWithBestLanguage[i].price) {
					broadcastsWithPrice.push(broadcastsWithBestLanguage[i]);
				}
			}

			cheapest = broadcastsWithPrice[0];
			for (i = 0; i < broadcastsWithPrice.length; i++) {
				if (cheapest.price > broadcastsWithPrice[i].price) {
					cheapest = broadcastsWithPrice[i];
				}
			}
			return cheapest;
		},

		/**
		 * returns details url which should show sportevent in tv-app - if not logged in, the use should at least be redirected to the sports-page
		 */
		getDetailsUrl: function() {
			return SCS.TV.SportEvent.getDetailsUrl(this.sportEventId);
		}
	};


	SCS.TV.SportEvent = SportEvent;

}(window.jQuery, window.SCS = window.SCS || {}, window.debug));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.SportEvent.js
// module id = 92
// module chunks = 0